import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dashboard__section" }
const _hoisted_2 = { class: "dashboard__header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "dashboard__section-title" }, "Your Integrations", -1)
const _hoisted_4 = { class: "dashboard__header-button-container" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" New Integration ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa_icon = _resolveComponent("fa-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_integration_card = _resolveComponent("integration-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_router_link, {
          class: "dashboard__header-button button--no-bg",
          to: `/dashboard/${_ctx.$route.params.subdomain}/integrations/new`
        }, {
          default: _withCtx(() => [
            _hoisted_5,
            _createVNode(_component_fa_icon, { icon: ['far', 'plus'] })
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ]),
    _createElementVNode("table", null, [
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.integrations, (integration) => {
          return (_openBlock(), _createBlock(_component_integration_card, {
            clickable: true,
            key: integration.id,
            integration: integration,
            onClick: ($event: any) => (_ctx.$router.push(
              `/dashboard/${_ctx.$route.params.subdomain}/integrations/${integration.id}`
            ))
          }, null, 8, ["integration", "onClick"]))
        }), 128))
      ])
    ])
  ]))
}